<script setup lang="ts">
  import SkeletonQC from '@qicgroupdoha/qic-connect-ds/components/SkeletonQC'
  import WrapperQC from '@qicgroupdoha/qic-connect-ds/components/WrapperQC'
  import FlowCardQC from '@/shared/components/FlowCardQC/FlowCardQC.vue'

  interface Props {
    variant?: 'default' | 'full'
  }

  withDefaults(defineProps<Props>(), {
    variant: 'default',
  })
</script>

<template>
  <FlowCardQC
    :with-button="false"
    class="flow-card-skeleton"
    :class="{ 'flow-card-skeleton--full': variant === 'full' }"
  >
    <template #header>
      <SkeletonQC width="100%" height="24px" style="max-width: 240px" />
      <SkeletonQC width="100%" :height="$qicConnect.isMobile ? '24px' : '44px'" />
    </template>
    <WrapperQC direction="column" gap="var(--spacing-5)">
      <SkeletonQC width="100%" height="60px" />
      <SkeletonQC width="100%" height="60px" />
    </WrapperQC>
  </FlowCardQC>
</template>

<style lang="scss" scoped>
  @use '@/shared/assets/styles/mixins';

  .flow-card-skeleton {
    height: 636px;

    @include mixins.mobile-flow {
      height: 600px;
    }

    &--full {
      height: 100vh;

      @include mixins.mobile-flow {
        height: 100vh;
      }
    }

    &__plane-loader {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
  }
</style>
